module.exports = __webpack_public_path__ + "img/5.93df09f8.jpg";